import React from 'react';
import { Redirect } from 'react-router-dom';
import { authRoles } from 'app/auth';
// TODO Update path to use ID not name
export const ClustersConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.user,
	routes: [
		{
			path: '/clusters/:id',
			component: React.lazy(() => import('./ClusterView'))
		},
		{
			path: '/clusters',
			component: React.lazy(() => import('./Clusters'))
		},
		{
			path: '/clusters',
			component: () => <Redirect to="/clusters" />
		}
	]
};
